import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { replaceAllConstraints } from '../constraintsSlice'
import { Constraint } from '../models/Constraint'

export const fetchConstraints = createAsyncThunk('constraints/fetchConstraints', async (_, { dispatch }) => {
  const constraints = await OLMSApiService.get<Constraint[]>('/constraint/list')

  if (constraints) {
    dispatch(replaceAllConstraints(constraints))
  }

  return constraints
})
